import {
  PlanResponseModel,
  ProductsResponseModel,
  ProductsLeftoutResponseModel,
  EmptyGrid,
} from "./plano.types";

export const SEGMENT_STYLE_COLORS: { [key: string]: string } = {
  CORE: "#f8b4b4",
  "CORE+": "#ff8a8a",
  VALUE: "#ab8212",
  PREMIUM: "#e6f514",
  SELTZER: "#778410",
  SODA: "#b0b842",
  EMPTY: "#8e8e8e",
  CRAFT: "#fbeec6",
  IMPORT: "#ee5959",
  PILSNER: "#7d66f0",
  LIGHTBLOND: "#08c4b7",
  RTD: "#a4f4b1",
  LAGER: "#61ea6a",
  PALE: "#11e820",
  extra7: "#118d2a",
  extra8: "#8edc18",
  extra9: "#e5ee72",
  extra10: "#e70404",
  extra11: "#5f4f4f",
  extra12: "#7e4444",
  extra14: "#c662a1",
  extra15: "#e70488",
  extra16: "#e609f6",
  extra17: "#fd96f4",
  extra18: "#92079c",
  extra19: "#b1b4fb",
  extra20: "#432cf2",
  extra21: "#20109e",
  extra22: "#a4ebf4",
  extra23: "#49dcdf",
};

export const SEGMENT_STYLE_COLORS_ARRAY = [
  "#f8b4b4",
  "#ff8a8a",
  "#ab8212",
  "#e6f514",
  "#778410",
  "#b0b842",
  "#fbeec6",
  "#ee5959",
  "#7d66f0",
  "#08c4b7",
  "#a4f4b1",
  "#61ea6a",
  "#11e820",
  "#118d2a",
  "#8edc18",
  "#e5ee72",
  "#e70404",
  "#5f4f4f",
  "#7e4444",
  "#c662a1",
  "#e70488",
  "#e609f6",
  "#fd96f4",
  "#92079c",
  "#b1b4fb",
  "#432cf2",
  "#20109e",
  "#a4ebf4",
  "#49dcdf",
  "#E68660",
  "#7B0206",
  "#A4E174",
  "#308716",
  "#C9F9FB",
  "#017DB2",
  "#FDF7CA",
  "#DDB500",
  "#F6C19F",
  "#F696BD",
  "#7B026F",
  "#E6CA60",
  "#936A03",
  "#A8A8F5",
  "#2840D8",
  "#33B73A",
  "#CA5AEC",
  "#77E3D4",
  "#187E8B",
  "#6DEB8D",
  "#904d4d",
  "#8FD2C2",
  "#DDAA9F",
  "#7B383E",
  "#F6F646",
  "#DDAA9F",
  "#24595B",
  "#f00ce6",
  "#BC807A",
  "#EEAB9D",
  "#F1C583",
  "#7A3510",
  "#43B867",
  "#F6B9F8",
  "#CC96E4",
  "#4E9D6D",
  "#8094b8",
];

export const DUMMY_PLAN_RESPONSE: any = {
  id: "502c48a6-7a08-4915-9bfb-a4da271c4c34",
  name: "Plan 1",
  state: "product_allocation",
  market_shares: {
    revenue: {
      ptc_segment: [
        {
          label: "VALUE",
          market_share: 30.02,
          user_allocated_share: 30.0,
        },
        {
          label: "CRAFT",
          market_share: 16.57,
          user_allocated_share: 16.5,
        },
        {
          label: "SODA",
          market_share: 15.11,
          user_allocated_share: 15.1,
        },
        {
          label: "CORE",
          market_share: 7.69,
          user_allocated_share: 7.7,
        },
        {
          label: "CIDER",
          market_share: 6.64,
          user_allocated_share: 6.7,
        },
        {
          label: "IMPORT",
          market_share: 4.95,
          user_allocated_share: 4.9,
        },
        {
          label: "SELTZER",
          market_share: 4.75,
          user_allocated_share: 4.8,
        },
        {
          label: "TEA",
          market_share: 4.03,
          user_allocated_share: 4.0,
        },
        {
          label: "COOLER",
          market_share: 3.97,
          user_allocated_share: 4.0,
        },
        {
          label: "CORE+",
          market_share: 2.7,
          user_allocated_share: 2.7,
        },
        {
          label: "COCKTAIL",
          market_share: 2.54,
          user_allocated_share: 2.5,
        },
        {
          label: "CAESAR",
          market_share: 1.01,
          user_allocated_share: 1.0,
        },
      ],
      style: [
        {
          label: "VALUE",
          market_share: 30.02,
          user_allocated_share: 30.02,
        },
        {
          label: "CRAFT",
          market_share: 16.57,
          user_allocated_share: 16.57,
        },
        {
          label: "SODA",
          market_share: 15.11,
          user_allocated_share: 15.11,
        },
        {
          label: "CORE",
          market_share: 7.69,
          user_allocated_share: 7.69,
        },
        {
          label: "CIDER",
          market_share: 6.64,
          user_allocated_share: 6.64,
        },
        {
          label: "IMPORT",
          market_share: 4.95,
          user_allocated_share: 4.95,
        },
        {
          label: "SELTZER",
          market_share: 4.75,
          user_allocated_share: 4.75,
        },
        {
          label: "TEA",
          market_share: 4.03,
          user_allocated_share: 4.03,
        },
        {
          label: "COOLER",
          market_share: 3.97,
          user_allocated_share: 3.97,
        },
        {
          label: "CORE+",
          market_share: 2.7,
          user_allocated_share: 2.7,
        },
        {
          label: "COCKTAIL",
          market_share: 2.54,
          user_allocated_share: 2.54,
        },
        {
          label: "CAESAR",
          market_share: 1.01,
          user_allocated_share: 1.01,
        },
      ],
    },
  },
  rules: [
    {
      title: "sequence_of_product_allocation",
      params: [
        { title: "traffic_flow", type: "string", value: "left_to_right" },
      ],
    },
  ],
  task_status: "completed",
  updated_at: "2023-02-15T06:09:03.750000",
  category: "ptc_segment",
  experiment_id: "40f861b7-d6cd-43f8-9e11-3f5abe7b450c",
  state_status: "completed",
  grid: {
    length: 250.0,
    height: 72.0,
    depth: 24.0,
    unit: "inch",
    dos: 7.0,
    doors: [
      {
        label: "Door 1",
        position: {
          x: {
            start: 0,
            end: 50,
          },
        },
        shelves: [
          {
            depth: 24,
            position: {
              y: {
                start: 0,
                end: 18,
              },
            },
            allocations: [
              {
                position: {
                  x: {
                    start: 0,
                    end: 50,
                  },
                },
                label: "VALUE",
              },
            ],
          },
          {
            depth: 24,
            position: {
              y: {
                start: 18,
                end: 36,
              },
            },
            allocations: [
              {
                position: {
                  x: {
                    start: 0,
                    end: 50,
                  },
                },
                label: "VALUE",
              },
            ],
          },
          {
            depth: 24,
            position: {
              y: {
                start: 36,
                end: 54,
              },
            },
            allocations: [
              {
                position: {
                  x: {
                    start: 0,
                    end: 50,
                  },
                },
                label: "VALUE",
              },
            ],
          },
          {
            depth: 24,
            position: {
              y: {
                start: 54,
                end: 72,
              },
            },
            allocations: [
              {
                position: {
                  x: {
                    start: 0,
                    end: 50,
                  },
                },
                label: "VALUE",
              },
            ],
          },
        ],
        depth: 24,
      },
      {
        label: "Door 2",
        position: {
          x: {
            start: 50,
            end: 100,
          },
        },
        shelves: [
          {
            depth: 24,
            position: {
              y: {
                start: 0,
                end: 18,
              },
            },
            allocations: [
              {
                position: {
                  x: {
                    start: 50,
                    end: 100,
                  },
                },
                label: "VALUE",
              },
            ],
          },
          {
            depth: 24,
            position: {
              y: {
                start: 18,
                end: 36,
              },
            },
            allocations: [
              {
                position: {
                  x: {
                    start: 50,
                    end: 100,
                  },
                },
                label: "VALUE",
              },
            ],
          },
          {
            depth: 24,
            position: {
              y: {
                start: 36,
                end: 54,
              },
            },
            allocations: [
              {
                position: {
                  x: {
                    start: 50,
                    end: 50,
                  },
                },
                label: "VALUE",
              },
              {
                position: {
                  x: {
                    start: 50,
                    end: 100,
                  },
                },
                label: "CRAFT",
              },
            ],
          },
          {
            depth: 24,
            position: {
              y: {
                start: 54,
                end: 72,
              },
            },
            allocations: [
              {
                position: {
                  x: {
                    start: 50,
                    end: 100,
                  },
                },
                label: "CRAFT",
              },
            ],
          },
        ],
        depth: 24,
      },
      {
        label: "Door 3",
        position: {
          x: {
            start: 100,
            end: 150,
          },
        },
        shelves: [
          {
            depth: 24,
            position: {
              y: {
                start: 0,
                end: 18,
              },
            },
            allocations: [
              {
                position: {
                  x: {
                    start: 100,
                    end: 150,
                  },
                },
                label: "CRAFT",
              },
            ],
          },
          {
            depth: 24,
            position: {
              y: {
                start: 18,
                end: 36,
              },
            },
            allocations: [
              {
                position: {
                  x: {
                    start: 100,
                    end: 115,
                  },
                },
                label: "CRAFT",
              },
              {
                position: {
                  x: {
                    start: 115,
                    end: 150,
                  },
                },
                label: "SODA",
              },
            ],
          },
          {
            depth: 24,
            position: {
              y: {
                start: 36,
                end: 54,
              },
            },
            allocations: [
              {
                position: {
                  x: {
                    start: 100,
                    end: 150,
                  },
                },
                label: "SODA",
              },
            ],
          },
          {
            depth: 24,
            position: {
              y: {
                start: 54,
                end: 72,
              },
            },
            allocations: [
              {
                position: {
                  x: {
                    start: 100,
                    end: 150,
                  },
                },
                label: "SODA",
              },
            ],
          },
        ],
        depth: 24,
      },
      {
        label: "Door 4",
        position: {
          x: {
            start: 150,
            end: 200,
          },
        },
        shelves: [
          {
            depth: 24,
            position: {
              y: {
                start: 0,
                end: 18,
              },
            },
            allocations: [
              {
                position: {
                  x: {
                    start: 150,
                    end: 166,
                  },
                },
                label: "SODA",
              },
              {
                position: {
                  x: {
                    start: 166,
                    end: 200,
                  },
                },
                label: "CORE",
              },
            ],
          },
          {
            depth: 24,
            position: {
              y: {
                start: 18,
                end: 36,
              },
            },
            allocations: [
              {
                position: {
                  x: {
                    start: 150,
                    end: 193,
                  },
                },
                label: "CORE",
              },
              {
                position: {
                  x: {
                    start: 193,
                    end: 200,
                  },
                },
                label: "CIDER",
              },
            ],
          },
          {
            depth: 24,
            position: {
              y: {
                start: 36,
                end: 54,
              },
            },
            allocations: [
              {
                position: {
                  x: {
                    start: 150,
                    end: 200,
                  },
                },
                label: "CIDER",
              },
            ],
          },
          {
            depth: 24,
            position: {
              y: {
                start: 54,
                end: 72,
              },
            },
            allocations: [
              {
                position: {
                  x: {
                    start: 150,
                    end: 160,
                  },
                },
                label: "CIDER",
              },
              {
                position: {
                  x: {
                    start: 160,
                    end: 200,
                  },
                },
                label: "IMPORT",
              },
            ],
          },
        ],
        depth: 24,
      },
      {
        label: "Door 5",
        position: {
          x: {
            start: 200,
            end: 250,
          },
        },
        shelves: [
          {
            depth: 24,
            position: {
              y: {
                start: 0,
                end: 18,
              },
            },
            allocations: [
              {
                position: {
                  x: {
                    start: 200,
                    end: 209,
                  },
                },
                label: "IMPORT",
              },
              {
                position: {
                  x: {
                    start: 209,
                    end: 250,
                  },
                },
                label: "PROMOTION",
              },
            ],
          },
          {
            depth: 24,
            position: {
              y: {
                start: 18,
                end: 36,
              },
            },
            allocations: [
              {
                position: {
                  x: {
                    start: 200,
                    end: 207,
                  },
                },
                label: "SELTZER",
              },
              {
                position: {
                  x: {
                    start: 207,
                    end: 247,
                  },
                },
                label: "TEA",
              },
              {
                position: {
                  x: {
                    start: 247,
                    end: 250,
                  },
                },
                label: "PROMOTION",
              },
            ],
          },
          {
            depth: 24,
            position: {
              y: {
                start: 36,
                end: 54,
              },
            },
            allocations: [
              {
                position: {
                  x: {
                    start: 200,
                    end: 237,
                  },
                },
                label: "COOLER",
              },
              {
                position: {
                  x: {
                    start: 237,
                    end: 250,
                  },
                },
                label: "CORE+",
              },
            ],
          },
          {
            depth: 24,
            position: {
              y: {
                start: 54,
                end: 72,
              },
            },
            allocations: [
              {
                position: {
                  x: {
                    start: 200,
                    end: 214,
                  },
                },
                label: "CORE+",
              },
              {
                position: {
                  x: {
                    start: 214,
                    end: 239,
                  },
                },
                label: "PROMOTION",
              },
              {
                position: {
                  x: {
                    start: 239,
                    end: 249,
                  },
                },
                label: "CAESAR",
              },
            ],
          },
        ],
        depth: 24,
      },
    ],
  },
  task_id: "f6826aaa-79bb-4460-97ae-7094e4ca3551",
  created_at: "2023-01-18T08:17:56.267000",
};

export const BASIC_SKU_DETAILS: any = [
  {
    label: "Segment",
    translatorLabel: "MY_PLANO.SEGMENT",
    key: "segment",
  },
  {
    label: "Style",
    translatorLabel: "MY_PLANO.STYLE",
    key: "style",
  },
  {
    label: "Manufacturer",
    translatorLabel: "MY_PLANO.MANUFACTURER",
    key: "manufacturer",
  },
  {
    label: "Pack Size",
    translatorLabel: "SYSTEM_RECOMMENDED.PACK_SIZE",
    key: "pack_size",
    decimalMethod: true,
    decimal: 2,
  },
  {
    label: "Pack Type",
    translatorLabel: "ADD_SKU.PACK_TYPE",
    key: "pack_type",
  },
  {
    label: "REVENUE",
    translatorLabel: "BASE_GRID.REVENUE",
    key: "revenue",
    space_key: "revenue_mean",
    decimalMethod: true,
    decimal: 2,
  },
  {
    label: "Volume",
    translatorLabel: "BASE_GRID.VOLUME",
    key: "volume",
    space_key: "volume_mean",
    decimalMethod: true,
    decimal: 2,
  },
  {
    label: "Units Sold",
    translatorLabel: "ADD_SKU.UNITS_SOLD",
    key: "units_sold",
    space_key: "units_sold_mean",
    decimalMethod: true,
  },
  {
    label: "Brand",
    translatorLabel: "MY_PLANO.BRAND",
    key: "brand",
  },
  {
    label: "Price",
    translatorLabel: "PRODUCT_SIDEBAR.PRICE",
    key: "price",
    decimalMethod: true,
    decimal: 2,
  },
  {
    label: "Reco Facing",
    translatorLabel: "MY_PLANO.RECOMMENDED_FACING_LABEL",
    key: "recommended_facing",
  },
  {
    label: "Overall DOS",
    translatorLabel: "MY_PLANO.OVERALL_DOS",
    key: "overall_dos",
    space_key: "overall_dos",
    decimalMethod: true,
    decimal: 2,
  },
  {
    label: "Unit Movement",
    translatorLabel: "MY_PLANO.UNIT_MOVEMENT",
    key: "unit_movement",
    space_key: "unit_movement",
    decimalMethod: true,
    decimal: 2,
  },
];

export const PACK_VARIANT_DETAILS: any = [
  {
    heading: "",
    formList: [
      {
        label: "Name",
        model: "name",
        isRequired: true,
        type: "dropdown",
        optionList: [
          "default",
          "tray",
          "case",
          "display",
          "alternate",
          "loose",
        ],
      },
    ],
  },
  {
    heading: "Configuration",
    errorKey: "configuration",
    info: "Configure the pack by specifying the number of units horizontally (H), vertically (V), and in depth (D). Total pack quantity is calculated as H * V * D.",
    formList: [
      {
        label: "Horizontal",
        model: "x",
        isRequired: false,
        valueKey: "inner_pack",
        min: 1,
        type: "input",
      },
      {
        label: "Vertical",
        model: "y",
        isRequired: false,
        valueKey: "inner_pack",
        min: 1,
        type: "input",
      },
      {
        label: "Depth",
        model: "z",
        isRequired: false,
        valueKey: "inner_pack",
        min: 1,
        type: "input",
      },
    ],
  },
  {
    heading: "Pack Qty Dimension (inch)",
    errorKey: "dimension",
    info: "Provide the overall dimensions of the pack, including length, height, and depth",
    formList: [
      {
        label: "Length",
        model: "width",
        isRequired: true,
        min: 1,
        type: "input",
      },
      {
        label: "Height",
        model: "height",
        isRequired: true,
        min: 1,
        type: "input",
      },
      {
        label: "Depth",
        model: "depth",
        isRequired: true,
        min: 1,
        type: "input",
      },
    ],
  },
];

export const FACING_ANALYSIS_COLUMNS: any = [
  {
    label: "SKU Name",
    colSpan: "",
    value: "sku_detail",
    valueType: "",
    sortable: true,
    filterType: "input_text",
    filterMatchMode: "contains",
  },
  {
    label: "Manufacturer",
    colSpan: "",
    value: "manufacturer",
    valueType: "",
    sortable: true,
    filterType: "input_text",
    filterMatchMode: "contains",
  },
  {
    label: "Brand",
    value: "brand",
    colSpan: "",
    valueType: "",
    sortable: true,
    filterType: "input_text",
    filterMatchMode: "contains",
  },
  {
    label: "Pack Qty",
    value: "pack_qty",
    colSpan: "",
    valueType: "",
    sortable: true,
    filterType: "input_text",
    filterMatchMode: "contains",
  },
  {
    label: "Style",
    value: "style",
    colSpan: "",
    valueType: "",
    sortable: true,
    filterType: "input_text",
    filterMatchMode: "contains",
  },
  {
    label: "Pack Type",
    value: "pack_type",
    colSpan: "",
    valueType: "",
    sortable: true,
    filterType: "input_text",
    filterMatchMode: "contains",
  },
  {
    label: "Pack Size",
    value: "pack_size",
    colSpan: "",
    valueType: "",
    sortable: true,
    filterType: "input_text",
    filterMatchMode: "contains",
  },
  {
    label: "Ptc Segment",
    value: "ptc_segment",
    colSpan: "",
    valueType: "",
    sortable: true,
    filterType: "input_text",
    filterMatchMode: "contains",
  },
  {
    label: "SKU Basket",
    value: "sku_plano_presence",
    colSpan: "",
    valueType: "",
    sortable: true,
    filterType: "input_text",
    filterMatchMode: "contains",
  },
  {
    label: "Pre Plano",
    spanText: "(A)",
    parseFloat: true,
    colSpan: "",
    value: "Pre Plano (A)",
    valueType: "",
    sortable: true,
    filterType: "comparison_filter",
    filterMatchMode: "contains",
  },
  {
    label: "System Reco.",
    spanText: "(B)",
    colSpan: "",
    parseFloat: true,
    value: "System Reco. (B)",
    valueType: "",
    sortable: true,
    filterType: "comparison_filter",
    filterMatchMode: "contains",
  },
  {
    label: "Difference",
    spanText: "(B-A) (%)",
    highlightData: true,
    parseFloat: true,
    colSpan: "",
    value: "Difference (B-A)",
    showDifferencePercentage: true,
    valueType: "",
    sortable: true,
    filterType: "comparison_filter",
    filterMatchMode: "contains",
  },
  {
    label: "New Plano",
    spanText: "(C)",
    colSpan: "",
    parseFloat: true,
    value: "New Plano (C)",
    valueType: "",
    sortable: true,
    filterType: "comparison_filter",
    filterMatchMode: "contains",
  },
  {
    label: "Difference",
    spanText: "(C-A) (%)",
    parseFloat: true,
    highlightData: true,
    showDifferencePercentage: true,
    colSpan: "",
    value: "Difference (C-A)",
    valueType: "",
    sortable: true,
    filterType: "comparison_filter",
    filterMatchMode: "contains",
  },
];

export const FACING_ANALYSIS_SELECT_OPTIONS: any = [
  {
    label: "Manufacturer",
    value: "manufacturer",
  },
  {
    label: "Brand",
    value: "brand",
  },
  {
    label: "Pack Qty",
    value: "pack_qty",
  },
  {
    label: "Style",
    value: "style",
  },
  {
    label: "Pack Type",
    value: "pack_type",
  },
  {
    label: "Pack Size",
    value: "pack_size",
  },
  {
    label: "Ptc Segment",
    value: "ptc_segment",
  },
  {
    label: 'SKU Basket',
    value: 'sku_plano_presence',
  }
];

export const FACING_ANALYSIS_NUMERIC_FILTER: any = [
  {
    label: "<=",
    value: "lte",
  },
  {
    label: ">=",
    value: "gte",
  },
  {
    label: "=",
    value: "equals",
  },
];

export const PRODUCT_LIBRARY_DETAILS: any = {
  tableList: [
    {
      label: "SKU ID",
      value: "sku",
      sortable: false,
      frozenColumn: true,
      alignFrozen: "left",
      filterType: "input_text",
      filterMatchMode: "contains"
    },
    {
      label: "SKU Name",
      value: "sku_detail",
      sortable: false,
      frozenColumn: true,
      alignFrozen: "left",
      filterType: "input_text",
      filterMatchMode: "contains",
      trimText: true,
    },
    {
      label: "Segment",
      value: "segment",
      sortable: false,
      filterType: "input_text",
      filterMatchMode: "contains",
      trimText: true,
    },
    {
      label: "Style",
      value: "style",
      sortable: false,
      filterType: "input_text",
      filterMatchMode: "contains",
      trimText: true,
    },
    {
      label: "Manufacturer",
      value: "manufacturer",
      sortable: false,
      filterType: "input_text",
      filterMatchMode: "contains",
      trimText: true,
    },
    {
      label: "Brand",
      value: "brand",
      sortable: false,
      filterType: "input_text",
      filterMatchMode: "contains",
      trimText: true,
    },
    {
      label: "Category",
      value: "category",
      sortable: false,
      filterType: "input_text",
      filterMatchMode: "contains",
      trimText: true,
    },
    {
      label: "Pack Type",
      value: "pack_type",
      sortable: false,
      filterType: "input_text",
      filterMatchMode: "contains",
      colMinWidth: true,
    },
    {
      label: "Pack Size",
      value: "pack_size",
      sortable: false,
      filterType: "input_text",
      filterMatchMode: "contains",
      colMinWidth: true,
    },
    {
      label: "Pack Quantity",
      value: "pack_quantity",
      sortable: false,
      filterType: "input_text",
      filterMatchMode: "contains",
      colMinWidth: true,
    },
    {
      label: "Length",
      value: "width",
      sortable: false,
      filterType: "input_text",
      filterMatchMode: "contains",
      colMinWidth: true,
    },
    {
      label: "Height",
      value: "height",
      sortable: false,
      filterType: "input_text",
      filterMatchMode: "contains",
      colMinWidth: true,
    },
    {
      label: "Depth",
      value: "depth",
      sortable: false,
      filterType: "input_text",
      filterMatchMode: "contains",
      colMinWidth: true,
    },
    {
      label: "Action",
      inputType: "action-icons",
      frozenColumn: true,
      colMinWidth: true,
      class: 'flex justify-center items-center',
      actionList: [
        { label: "Add to Exp", key: "add", icon: 'icon-add', disableKey: 'added_to_exp', isLoadingKey: 'isLoading' },
        // { label: "History", key: "history", icon: 'icon-time', disableKey: '', isLoadingKey: '' },
      ],
    },
  ],
};
